import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "antd";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const groupByDateWithType = (array, type) => {
  const grouped = {};
  array.forEach((item) => {
    const dateKey = dayjs(item.date_exam).format("DD/MM/YYYY");
    if (!grouped[dateKey]) grouped[dateKey] = [];
    grouped[dateKey].push({
      id: item.code_module,
      name: item.name_module,
      start: item.heure_deb_exam,
      end: item.heure_fin_exam,
      room: item.salle_exam,
    });
  });

  return Object.keys(grouped).map((dateKey) => ({
    type,
    date: dateKey,
    modules: grouped[dateKey],
  }));
};

const ConsulterDetailsCalendrierExamenRattrapage = () => {
  const [calendarData, setCalendarData] = useState([]);
  const params = useLocation();
  const result = params.state?.result;

  useEffect(() => {
    const examens = result.examen ? groupByDateWithType(result.examen, "examen") : [];
    const rattrapages = result.rattrapage
      ? groupByDateWithType(result.rattrapage, "rattrapage")
      : [];
    setCalendarData([...examens, ...rattrapages]);
  }, []);

  return (
    <div style={{ padding: "24px" }}>
      {calendarData?.length === 0 && (
        <p style={{ marginTop: 20 }}>Aucune donnée disponible pour cette période.</p>
      )}

      {(() => {
        const titlesShown = new Set();

        return calendarData
          .sort((a, b) => dayjs(a.date, "DD/MM/YYYY") - dayjs(b.date, "DD/MM/YYYY"))
          .map(({ type, date, modules }, index) => {
            const isExam = type === "examen";
            const color = isExam ? "#2a96ff" : "#ffb836";
            const bgColor = isExam ? "#f0f5ff" : "#fff7e6";
            const borderColor = isExam ? "#6197cb" : "#ffd591";

            const titleBlock = !titlesShown.has(type) ? (
              <h2
                style={{
                  color,
                  marginBlock: 10,
                  fontSize: 20,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <CalendarOutlined /> {isExam ? "Calendrier Examen" : "Calendrier Rattrapage"}
              </h2>
            ) : null;

            titlesShown.add(type);

            return (
              <div key={type + date + index}>
                {titleBlock}
                <Card
                  title={
                    <span style={{ fontWeight: "bold", color, fontSize: 16 }}>
                     
                      {dayjs(date, "DD/MM/YYYY")
                        .format("dddd DD/MM/YYYY")
                        .replace(/^./, (c) => c.toUpperCase())}
                    </span>
                  }
                  size="small"
                  style={{
                    marginBottom: 20,
                    backgroundColor: bgColor,
                    border: `1px solid ${borderColor}`,
                    borderRadius: 12,
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  }}
                >
  {modules.map((mod) => (
  <div
    key={mod.id}
    style={{
      padding: 10,
      backgroundColor: "#fff",
      borderRadius: 8,
      marginBottom: 8,
      border: "1px solid #f0f0f0",
      display: "flex",
      alignItems: "center",
      gap: 24, // espace entre chaque info
      fontSize: 14,
      fontWeight: 500,
      flexWrap: "wrap",
    }}
  >
    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <span style={{ color: "#222" }}>{mod.name}</span>
    </span>

    <span style={{ display: "flex", alignItems: "center", gap: 4, }}>
      <ClockCircleOutlined style={{ color: "#ff808B" }} /> {mod.start} à {mod.end}
    </span>

    <span style={{ display: "flex", alignItems: "center", gap: 4, }}>
      <EnvironmentOutlined style={{ color: "#ff808B" }} /> Salle : {mod.room}
    </span>
  </div>
))}

                </Card>
              </div>
            );
          });
      })()}
    </div>
  );
};

export default ConsulterDetailsCalendrierExamenRattrapage;
